import { daUtils } from '../_utils';
import { IApiResponse } from './types';
import { API_PAF_BASE_URI } from './index';

const API_NOTIFICATIONS = `${API_PAF_BASE_URI}/notifications`;
const API_NOTIFICATIONS_MARK_AS_READ = `${API_PAF_BASE_URI}/notifications/mark-read/`;

export interface INotification {
    id: string;
    message: string;
    date: string; // ISO 8601 datetime
    isRead: boolean;
    createdAt?: string;
}

export interface INotificationsResponse {
    notifications: INotification[];
    unreadCount: number;
    totalCount: number;
}

export interface IMarkAsReadRequest {
    notification_ids: number[];
}

/**
 * Fetch all notifications for the current user
 */
const getNotifications = async (
    auth_token: string | undefined = undefined
): Promise<IApiResponse> => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
        };
        const url = API_NOTIFICATIONS;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);
        return resp;
    } catch (error: any) {
        throw error;
    }
};

// Removed getUnreadCount: now handled by getNotifications response

/**
 * Mark notifications as read
 */
const markAsRead = async (
    options: IMarkAsReadRequest,
    auth_token: string | undefined = undefined
): Promise<IApiResponse> => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options),
        };
        const url = API_NOTIFICATIONS_MARK_AS_READ;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);
        return resp;
    } catch (error: any) {
        throw error;
    }
};

export const notificationApi = {
    getNotifications,
    markAsRead,
};
